import {
  GET_CALL_PRICES,
  GET_CALL_PRICES_SUCCESS,
  GET_CALL_PRICES_ERROR,

} from "./actionTypes"

export const getCallPrices = payload => {
  return {
    type: GET_CALL_PRICES,
    payload: payload,
  }
}

export const getCallPricesSuccess = lead_prices => {
  return {
    type: GET_CALL_PRICES_SUCCESS,
    payload: lead_prices,
  }
}

export const getCallPricesError = error => {
  return {
    type: GET_CALL_PRICES_ERROR,
    payload: error,
  }
}
